<template>
	<div class="gvf">
		<v-menu
			offset-y
			:close-on-content-click="false"
			:open-on-focus="true"
			v-model="menuStatus"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:disabled="isNull"
					:tabindex="tabIndex"
					readonly
					clearable
					v-bind="attrs"
					v-on="on"
					:label="gridViewField.Label"
					hide-details="auto"
					@click:clear="onClear"
					v-model="value"
				>
					<template v-slot:append>
						<v-icon v-if="menuStatus">mdi-menu-up</v-icon>
						<v-icon v-else class="rotate">mdi-menu-up</v-icon>
					</template></v-text-field
				>
			</template>
			<div style="background-color: white">
				<v-row no-gutters class="mx-5" style="align-items: flex-end">
					<v-text-field
						append-icon="mdi-magnify"
						clearable
						v-model="search"
						hide-details="true"
						label="Search"
					></v-text-field>
				</v-row>
				<v-list v-if="filteredItems">
					<v-list-item-group
						v-model="selected"
						active-class="primary white--text"
						class="field-list"
					>
						<v-list-item
							v-for="(item, index) in filteredItems"
							@click.prevent="onSelectItem(item)"
							:key="index"
							:value="item"
						>
							<v-list-item-content>
								<v-list-item-title>
									{{ item.Value }}</v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</div>
		</v-menu>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="onClear()"
		></v-checkbox>
	</div>
</template>

<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import dataFieldUtils from '../../../../utils/dataFieldUtils';
import { mapGetters } from 'vuex';
import { GridsGetters } from '../../../../store/getters';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';

export default {
	name: 'ReferenceField',
	mixins: [gridFieldMixin],
	data() {
		return {
			menuStatus: false,
			search: '',
			selected: null,
			value: null,
		};
	},
	computed: {
		...mapGetters({
			referenceListValues: [GridsGetters.GET_REFERENCE_LIST_VALUES],
		}),

		referenceListTypeId() {
			if (!this.gridViewField) return null;
			return this.gridViewField.ReferenceListTypeId;
		},

		allValues() {
			if (!this.referenceListTypeId) return [];
			return this.referenceListValues
				.filter((x) => x.TypeId == this.referenceListTypeId)
				.sort((a, b) => a.Order - b.Order);
		},
		filteredItems() {
			if (!this.search) return this.allValues;
			return this.allValues.filter(
				(x) =>
					x.Value &&
					x.Value.toLowerCase().includes(this.search.toLowerCase())
			);
		},
		itemKey() {
			if (!this.gridViewField) return null;
			return gridViewFieldsUtils.getFieldName(this.gridViewField);
		},
		dataFieldKey() {
			if (!this.gridViewField) return null;
			if (!this.gridViewField.DataField) return null;
			return dataFieldUtils.getDataFieldName(
				this.gridViewField.DataField
			);
		},
	},
	watch: {
		menuStatus(newVal) {
			if (!newVal) {
				this.search = null;
				return;
			}
			if (this.search === null) this.search = this.value;
		},
	},
	mounted() {
		if (this.item && this.record && this.itemKey && this.dataFieldKey) {
			if (this.item[this.itemKey] && this.item[this.dataFieldKey]) {
				this.selected = {
					Id: this.item[this.dataFieldKey],
					Value: this.item[this.itemKey],
				};
				this.value = this.selected.Value;
			}
		}
	},
	methods: {
		onClear() {
			this.selected = null;
			this.value = null;
			this.changeValue(null);
		},
		onSelectItem(referenceListValue) {
			this.selected = referenceListValue;
			this.value = referenceListValue.Value;
			this.menuStatus = false;
			this.changeValue(referenceListValue);
		},

		changeValue(selectedRow) {
			let selectedRowId = null;
			let selectedRowValue = null;
			if (selectedRow) {
				selectedRowId = selectedRow.Id;
				selectedRowValue = selectedRow.Value;
			}
			let recordKey = [{ key: this.key, value: selectedRowId }];
			let itemKey = [
				{ key: this.dataFieldKey, value: selectedRowId },
				{ key: this.itemKey, value: selectedRowValue },
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>
<style lang="scss">
.rotate {
	transform: rotate(180deg);
}
</style>
